import { colors, Paragraph } from 'component-library';
import { KeyValuePairWrapper, SecondaryLabelWrapper, ValueWrapper } from './styles';
import type React from 'react';

export const KeyValuePair = ({
  label,
  value,
  bold,
  secondaryLabel,
  secondaryLabelGray,
}: {
  label: string;
  value?: string | React.ReactNode;
  bold?: boolean;
  secondaryLabel?: string;
  secondaryLabelGray?: boolean;
}) => {
  if (!value) {
    return null;
  }

  return (
    <KeyValuePairWrapper>
      <Paragraph bold={bold} color={bold ? colors.base.black : colors.primary.grey}>
        {label}
      </Paragraph>
      <ValueWrapper>
        <Paragraph color={colors.base.black}>{value}</Paragraph>
        {secondaryLabel && (
          <SecondaryLabelWrapper>
            <Paragraph color={secondaryLabelGray ? colors.primary.grey : colors.base.black}>
              {secondaryLabel}
            </Paragraph>
          </SecondaryLabelWrapper>
        )}
      </ValueWrapper>
    </KeyValuePairWrapper>
  );
};
